import { render, staticRenderFns } from "./ManageCommpanyBrandList.vue?vue&type=template&id=59a1e386&"
import script from "./ManageCommpanyBrandList.vue?vue&type=script&lang=js&"
export * from "./ManageCommpanyBrandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports